export default class Tab {
    constructor(main) {
        this.main = main;

        this._setTab();
    }

    _setTab() {
        const $tabs = [...document.querySelectorAll('.js-tab')];

        for (const $tab of $tabs) {
            this._eventBind($tab);
        }
    }

    _eventBind($tab) {
        const $btns = [...$tab.querySelectorAll('.js-tab_btn')];
        const $conts = [...$tab.querySelectorAll('.js-tab_cont')];

        $btns.forEach(($btn, i) => {
            $btn.addEventListener('click', () => {
                const $selectedBtn = $btns.find(($btn) => $btn.classList.contains('-select'));
                const $selectedCont = $conts.find(($cont) => $cont.classList.contains('-select'));

                // 選択クラスの切り替え
                $selectedBtn.classList.remove('-select');
                $selectedCont.classList.remove('-select');
                $btn.classList.add('-select');
                $conts[i].classList.add('-select');

                // アコーディオンの高さを初期化
                this.main.acc.setHeight();
            });
        });
    }
}
